import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models/app-state.interface';
import { LOGGING_SERVICE, LoggingServiceInterface } from 'app/core/browser/services/index';
import { ErrorInterface } from 'app/core/error-handler/models/error.model';
import { ErrorRaisedRemoved } from 'app/core/error-handler/state/actions/error-raised.model';
import { ErrorStateInterface } from 'app/core/error-handler/state/models';
import { LogLevel } from 'app/core/logging/constants/log-level.constant';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs';

import { ErrorHandlerServiceInterface } from './error-handler-service.interface';

@Injectable()
export class ErrorHandlerService extends ErrorHandler implements ErrorHandlerServiceInterface {
  constructor(@Inject(LOGGING_SERVICE) private readonly _loggingService: LoggingServiceInterface,
              private readonly _store: Store<AppStateInterface>) {
    super();
  }

  /**
   * handleError
   *
   * Override framework error handling if ErrorService is provided
   *
   * @param error The error for the framework to handle
  */
  public handleError(error: any): void {
    this._loggingService.log(LogLevel.error, error);

    super.handleError(error);
  }

  /**
   * error
   *
   * Log an error with the error service
   *
   * @param error The error to pass into the error service
  */
  public error(errorRaised: ErrorInterface): void {
    // log message may need to be tweaked based on the fidelity of the error response from the services
    this._loggingService.log(
      LogLevel.error,
      `${errorRaised.source}. ` +
      `${errorRaised.errorResponse && !environment.production ? errorRaised.errorResponse.message : errorRaised.message}. ` +
      `${errorRaised.exception ? errorRaised.exception : ''}`,
    );
  }

  public loadError(): Observable<ErrorStateInterface> {
    return this._store.select(({ error }: AppStateInterface) => error);
  }

  public removeError(): void {
    this._store.dispatch(new ErrorRaisedRemoved());
  }
}
